import * as React from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Dialog } from "@progress/kendo-react-dialogs";
import { Field, Form, FormElement } from "@progress/kendo-react-form";
import { Button } from "@progress/kendo-react-buttons";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { Input } from "@progress/kendo-react-inputs";
import { Upload } from "@progress/kendo-react-upload";
import { Error } from "@progress/kendo-react-labels";
import { getter } from "@progress/kendo-react-common";


const EditDocumentForm = (props) => {
  const [files, setFiles] = React.useState([]);
  const [formattedFolders, setFormattedFolders] = React.useState([]);
  const [selectedFolder, setSelectedFolder] = React.useState({});
  const [toggleState, setToggleState] = React.useState(props.item?.file ? 2 : (props.item?.hyperlink ? 1 : 0));

  const { token } = useSelector(state => state.authReducer);

  const isFile = props?.item?.type == 'file';

  const submit = (event, props) => {
    const folderId = toggleState == 2 ? null : (event.Folder?.id ?? null);
    if (toggleState == 1 && !props.item.id) {//Is new hyperlink
      const expression = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gi;
      if (!event?.hyperlink?.match(expression)) {
        window.alert('Invalid URL supplied');
      } else {
        props.onSubmit({ ...event, folderId }, files, event.Groups);
      }
    } else if (toggleState == 0 && !props.item?.id &&(!files || !files[0] || ![".jpg", ".png", ".ppt", ".pptx", ".doc", ".docx", ".xls", ".xlsx", ".pdf", ".bmp", ".gif", ".txt", ".csv", ".zip"].includes(files[0].extension))) {
      window.alert('Invalid File Type');  
    } else {
      props.onSubmit({ ...event, folderId }, files, event.Groups);
    }
  }

  console.log(props.item.type)

  React.useEffect(() => {
    if (props.item?.file) {
      if (props.item?.file.includes('http')) {
        setToggleState(1);
      } else {
        setToggleState(0);
      }
    } else if (!isFile) {
      setToggleState(2);
    }
  }, [props.item]);

  React.useEffect(() => {
    if (props.folders) {
      let options = Object.entries(props.folders).map(folder => { return { ...folder[1], folderId: folder[1].id } }).filter(folder => folder.id !== props.item.id);
      options.push({ folderId: null, filename: 'No Folder' });
      setFormattedFolders(options);
    }
  }, [props.folders, props.item])

  const FormMultiSelect = (fieldRenderProps) => {
    const { validationMessage, visited, ...others } = fieldRenderProps;

    return (
      <div>
        <MultiSelect
          data={props.groups}
          textField="name"
          dataItemKey="id"
          {...others} />
        {visited && validationMessage && <Error>{validationMessage}</Error>}
      </div>
    )
  }

  const FormDropDown = (fieldRenderProps) => {
    const { validationMessage, visited, ...others } = fieldRenderProps;
    return (
      <div>
        <DropDownList
          data={formattedFolders}
          textField="filename"
          dataItemKey="folderId"
          {...others} />
        {visited && validationMessage && <Error>{validationMessage}</Error>}
      </div>
    )
  }
  const FormStringInput = (fieldRenderProps) => {
    const { validationMessage, visited, ...others } = fieldRenderProps;
    return (
      <div>
        <Input {...others} />
        {
          visited && validationMessage && <Error direction={"end"} style={{ flexDirection: 'column' }}>{validationMessage}</Error>
        }
      </div>
    );
  };

  const FormInput = (fieldRenderProps) => {
    const { validationMessage, visited, ...others } = fieldRenderProps;
    return (
      <div id="uploadContainer">
        <Upload 
          autoUpload={false}
          withCredentials={false}
          multiple={false}
          files={files}
          onAdd={(e) => setFiles(e.newState)}
          onRemove={(e) => setFiles(e.newState)}
          onProgress={(e) => setFiles(e.newState)}
          onStatusChange={(e) => setFiles(e.newState)}
          restrictions={{
            allowedExtensions: [".zip", ".jpg", ".png", ".ppt", ".pptx", ".doc", ".docx", ".xls", ".xlsx", ".pdf", ".bmp", ".gif", ".txt", ".csv"],
          }}
        />
        {
          visited && validationMessage && <Error direction={"end"} style={{ flexDirection: 'column' }}>{validationMessage}</Error>
        }
      </div>
    );
  };

  const renderForm = () => {
    switch(toggleState) {
      case 0:
        return (
          <div className="mb-3" style={styles.formField}>
            <Field name={"region"} defaultValue={props.item?.file} component={FormInput} label={"Region"} />
          </div>
        )
      case 1:
        return (
          <>
            <div className="mb-3" style={styles.formField}>
              <Field name={"hyperlink"} defaultValue={props.item?.file} component={FormStringInput} label={"URL"} />
            </div>
            <div className="mb-3" style={styles.formField}>
              <Field name={"filename"} defaultValue={props.item?.filename} component={FormStringInput} label={"URL Description"} />
            </div>
          </>
        )
      case 2:
        return (
          <>
            <div className="mb-3" style={styles.formField}>
              <Field name={"folderName"} defaultValue={props.item?.filename} component={FormStringInput} label={"Folder Name"} />
            </div>
          </>
        )
      default:
        break;
    }
  }

  const stateString = () => {
    switch (toggleState) {
      case 0:
        return 'Document';
      case 1:
        return 'Hyperlink';
      case 2:
        return 'Folder';
      default:
        return 'Document'
    }
  }

  return <Dialog
    title={props.item.id ? `Edit ${stateString()}` : `Create ${stateString()}`}
    style={{ zIndex: 2 }}
    onClose={props.cancelEdit}
  >
    <Form
      style={{ maxHeight: '600px', minWidth: '500px' }}
      onSubmit={(e) => submit(e, props)}
      initialValues={props.item}
      ignoreModified={true}
      render={(formRenderProps) => (
        <FormElement style={styles.formElement}>
          <fieldset className={"k-form-fieldset"}>
            <div style={{ height: '460px', paddingRight: '10px', overflowY: 'scroll' }}>
              <div style={styles.accountDiv}>
                <div className="mb-3" style={styles.formFieldButton}>
                  {isFile && <Button className="k-button k-primary" type={"button"} togglable={true} onClick={() => setToggleState(toggleState ? 0 : 1)}>
                    Toggle Document Type
                  </Button>}
                </div>
                {renderForm()}
                <div className="mb-3" style={styles.formField}>
                  <Field name={"Groups"} component={FormMultiSelect} label={"Groups"} />
                </div>
                {toggleState == 0 || toggleState == 1 ? <div className="mb-3" style={styles.formField}>
                  <Field 
                  name={"Folder"} 
                  defaultValue={
                    props.item.folderId && props.folders[props.item.folderId] ?
                     { folderId: props.item.folderId, filename: props.folders[props.item.folderId].filename } :
                     { folderId: null, filename: 'No Folder' }
                  } 
                  component={FormDropDown} label={"Folder"} />
                </div> : null}
              </div>
            </div>
          </fieldset>
          <div className="k-form-buttons k-justify-content-end" style={{ paddingBottom: '10px' }}>
            <button type={"submit"} className="k-button k-primary" style={styles.modalBtn} disabled={false}>
              Save
            </button>
            <button type={"submit"} className="k-button" style={styles.modalBtn} onClick={props.cancelEdit}>
              Cancel
            </button>
          </div>
        </FormElement>
      )}
    />
  </Dialog>
}

const styles = {
  formElement: {
    minWidth: 465,
    maxHeight: 525,
    minHeight: 525
  },
  formField: {
    marginTop: 10,
    marginBottom: 25,
  },
  formFieldButton: {
    marginTop: 10,
    marginBottom: 25,
    textAlign: 'center',
  },
  formLabel: {
    fontWeight: 'bold',
    fontSize: 18,
  },
  adminSection: {
    marginTop: 20,
    display: 'flex',
    justifyContent: 'space-around',
    flexDirection: 'row'
  },
  modalBtn: {
    padding: '10px 15px'
  },
  accountDiv: {
    backgroundColor: '#F5F5F5',
    padding: '8px',
    border: '2px solid #DCDCDC',
    borderRadius: '6px'
  }
  //    padding: 8px 24px;
}

export default EditDocumentForm;